import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify)

const vuetify = new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#67833D',
                secondary: '#DB7B58',
                accent: '#D0B250',
                error: '#A95657',
                red: '#A95657',
                green: '#67833D',
            },
        },
    },
})

export default vuetify
